<ion-item-group>
  <ion-item-divider sticky>
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/account_circle_24dp.svg"
    ></ion-icon>
    <div>
      <p class="subtitle">{{ 'register.sections.user' | translate }}</p>
    </div>
  </ion-item-divider>

  <div [formGroup]="form()">
    <ion-grid class="ion-padding">
      <ion-row>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="firstName"
            [errorText]="getErrorMessage('firstName') | translate"
            label="{{ 'register.labels.first_name' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.first_name' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="lastName"
            [errorText]="getErrorMessage('lastName') | translate"
            label="{{ 'register.labels.last_name' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.last_name' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="email"
            [errorText]="getErrorMessage('email') | translate"
            type="email"
            label="{{ 'register.labels.email' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.email' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
          ></ion-input>
        </ion-col>
        <ion-col
          size-lg="6"
          size="12"
        >
          <ion-input
            formControlName="phone"
            [errorText]="getErrorMessage('phone') | translate"
            type="tel"
            label="{{ 'register.labels.phone' | translate }}"
            labelPlacement="floating"
            placeholder="{{ 'register.place_holder.phone' | translate }}"
            fill="outline"
            mode="md"
            [clearInput]="true"
          ></ion-input>
        </ion-col>

        <ion-col size="12">
          <ion-item lines="none">
            <ion-checkbox
              formControlName="privacyPolicyAccepted"
              label-placement="end"
            >
              {{ 'register.privacy_policy_prefix' | translate }}
              <a
                [href]="legalLinks.privacyUrl"
                target="_blank"
              >
                {{ 'register.link.privacy_policy' | translate }}
              </a>
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <ion-item lines="none">
            <ion-checkbox
              formControlName="termsAndConditionsAccepted"
              label-placement="end"
            >
              {{ 'register.terms_conditions_prefix' | translate }}
              <a
                [href]="legalLinks.termsUrl"
                target="_blank"
              >
                {{ 'register.link.terms_conditions' | translate }}
              </a>
            </ion-checkbox>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-item-group>
